import tgoCity from './linkSelect.vue'

export default tgoCity
